module.exports = __webpack_public_path__ + "static/media/starOutline.dbe8d934.svg";